import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { useCallback, useEffect, useState } from "react";

import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { APIStatus } from "@/redux/modules/api/data/cart/cart.module";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const storePickerFixedFeatures = [
    StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE
];

type Props = {
    changeStore: (store: string) => Promise<any>;
    onChangeStore: () => void;
    storeName?: string;
    storeCode?: string;
};

const ProductInfoBlock = ({
    changeStore,
    onChangeStore,
    storeName,
    storeCode
}: Props) => {
    const { t } = useGranite();
    const [isStorePickerOpen, setIsStorePickerOpen] = useState(false);

    useEffect(() => {
        return function cleanUp() {
            setIsStorePickerOpen(false);
        };
    }, []);

    const innerOnChangeStore = () => {
        onChangeStore();
        setIsStorePickerOpen(true);
    };

    const handleOnStorePickerSubmit = useCallback(
        (store: CloudStore, onClose?: () => void) => {
            onClose?.();
            changeStore(store.code).then((action) => {
                if (action.type === APIStatus.FAILURE) {
                    broadcastMessage({
                        id: "shoppingCart-error",
                        text: action.payload.message,
                        status: "danger",
                        dismissible: true
                    });
                }
            });
        },
        [changeStore]
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const handleOnStorePickerClose = useCallback(
        () => setIsStorePickerOpen(false),
        [setIsStorePickerOpen]
    );

    return (
        <>
            <div className="mr-3 py-2">{storeName}</div>
            <Button
                test="productInfoBlock-button-switchStore"
                className={"px-0 py-2 align-content-center"}
                color={"link"}
                onClick={innerOnChangeStore}
                type={"button"}
            >
                {t("general.cart.label.switchStore")}
            </Button>
            <span className="py-2">
                <Tooltip
                    title={t("general.cart.label.switchStore.tooltip.title")}
                    innerHTML={t(
                        "general.cart.label.switchStore.tooltip.content"
                    )}
                />
            </span>
            <StorePickerModal
                type={StorePickerType.SELECT}
                isOpen={isStorePickerOpen}
                storeCode={storeCode ?? null}
                infoLink={null}
                onClose={handleOnStorePickerClose}
                displayStockLevel={false}
                fixedFeatures={storePickerFixedFeatures}
                fixedFilters={[]}
                filterStoreType={StoreType.WalkIn}
                onSubmit={handleOnStorePickerSubmit}
            />
        </>
    );
};

export default ProductInfoBlock;
